import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxEchartsModule } from 'ngx-echarts';

import { RapportsComponent } from './rapports.component';
import { RapportQualiteComponent } from './qualite/rapport-qualite.component';
import { RapportSatisfactionComponent } from './satisfaction/rapport-satisfaction.component';
import { RapportFinanceComponent } from './finance/rapport-finance.component';
import { RapportVolumesComponent } from './volumes/rapport-volumes.component';

@NgModule({
  declarations: [
    RapportsComponent,
    RapportQualiteComponent,
    RapportSatisfactionComponent,
    RapportFinanceComponent,
    RapportVolumesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') })
  ],
  exports: [
    RapportsComponent
  ]
})
export class RapportsModule {}
